import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { axiosInstance } from '../../axios/interceptor'

export const getAllReport = createAsyncThunk('Report/all', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/property-schedule/get-schedule-calendar`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getReportCategory = createAsyncThunk('Report/category', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/cleaning-reports-category/get-cleaning-reports-category`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getRegionWiseReport = createAsyncThunk('Report/get-region-wise-reports', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/reports/get-region-wise-reports`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getRegionWiseInActiveReport = createAsyncThunk('Report/get-region-wise-inactive-reports', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/reports/get-region-wise-reports`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getBestCleanersReport = createAsyncThunk('Report/get-best-cleaners', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/reports/get-best-cleaners`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getBestPropertyReport = createAsyncThunk('Report/get-best-properties', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/reports/get-best-properties`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getGeneralMatrixReport = createAsyncThunk('Report/get-general-matrix', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/reports/get-general-matrix`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getRegionBestPropertyReport = createAsyncThunk('Report/get-region-best-properties', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/reports/get-region-best-properties`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getRegionBestCleaners = createAsyncThunk('Report/get-region-best-cleaners', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/reports/get-region-best-cleaners`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getRegionBestClient = createAsyncThunk('Report/get-region-best-clients', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/reports/get-region-best-clients`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getRegionWiseClients = createAsyncThunk('Report/get-region-wise-clients', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/reports/get-region-wise-clients`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getRegionWiseCleaners = createAsyncThunk('Report/get-region-wise-cleaners', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/reports/get-region-wise-cleaners`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getRegionWiseProperty = createAsyncThunk('Report/get-region-wise-properties', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/reports/get-region-wise-properties`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getRegionMatrixReport = createAsyncThunk('Report/get-region-wise-matrix', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/reports/get-region-wise-matrix`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

const initialState = {
  isLoading: false,
  allReport: [],
  reportCategory: [],
  allRegionReport: [],
  allRegionInActiveReport:[],
  allBestCleaners: [],
  allBestProperty: [],
  reportGeneralMatrix: [],
  allRegionBestProperty: [],
  allRegionBestCleaners: [],
  allRegionBestClient: [],
  allRegionCleaners: [],
  allRegionClient: [],
  allRegionProperty: [],
  reportRegionMatrix: [],
  error: null
}

const ReportSlice = createSlice({
  name: 'Report',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getAllReport.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getAllReport.fulfilled, (state, action) => {
        state.isLoading = false
        state.allReport = action.payload?.data?.data
      })
      .addCase(getAllReport.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getReportCategory.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getReportCategory.fulfilled, (state, action) => {
        state.isLoading = false
        state.reportCategory = action.payload?.data?.data
      })
      .addCase(getReportCategory.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })

      .addCase(getRegionWiseReport.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getRegionWiseReport.fulfilled, (state, action) => {
        state.isLoading = false
        state.allRegionReport = action.payload?.data?.data
      })
      .addCase(getRegionWiseReport.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })

      .addCase(getRegionWiseInActiveReport.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getRegionWiseInActiveReport.fulfilled, (state, action) => {
        state.isLoading = false
        state.allRegionInActiveReport = action.payload?.data?.data
      })
      .addCase(getRegionWiseInActiveReport.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      // getRegionWiseInActiveReport

      .addCase(getBestCleanersReport.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getBestCleanersReport.fulfilled, (state, action) => {
        state.isLoading = false
        state.allBestCleaners = action.payload?.data?.data
      })
      .addCase(getBestCleanersReport.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })

      .addCase(getBestPropertyReport.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getBestPropertyReport.fulfilled, (state, action) => {
        state.isLoading = false
        state.allBestProperty = action.payload?.data?.data
      })
      .addCase(getBestPropertyReport.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })

      .addCase(getGeneralMatrixReport.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getGeneralMatrixReport.fulfilled, (state, action) => {
        state.isLoading = false
        state.reportGeneralMatrix = action.payload?.data?.data
      })
      .addCase(getGeneralMatrixReport.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })

      .addCase(getRegionBestPropertyReport.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getRegionBestPropertyReport.fulfilled, (state, action) => {
        state.isLoading = false
        state.allRegionBestProperty = action.payload?.data?.data
      })
      .addCase(getRegionBestPropertyReport.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })

      .addCase(getRegionBestCleaners.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getRegionBestCleaners.fulfilled, (state, action) => {
        state.isLoading = false
        state.allRegionBestCleaners = action.payload?.data?.data
      })
      .addCase(getRegionBestCleaners.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })

      .addCase(getRegionBestClient.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getRegionBestClient.fulfilled, (state, action) => {
        state.isLoading = false
        state.allRegionBestClient = action.payload?.data?.data
      })
      .addCase(getRegionBestClient.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })

      .addCase(getRegionWiseClients.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getRegionWiseClients.fulfilled, (state, action) => {
        state.isLoading = false
        state.allRegionClient = action.payload?.data?.data
      })
      .addCase(getRegionWiseClients.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })

      .addCase(getRegionWiseCleaners.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getRegionWiseCleaners.fulfilled, (state, action) => {
        state.isLoading = false
        state.allRegionCleaners = action.payload?.data?.data
      })
      .addCase(getRegionWiseCleaners.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })

      .addCase(getRegionWiseProperty.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getRegionWiseProperty.fulfilled, (state, action) => {
        state.isLoading = false
        state.allRegionProperty = action.payload?.data?.data
      })
      .addCase(getRegionWiseProperty.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })

      .addCase(getRegionMatrixReport.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getRegionMatrixReport.fulfilled, (state, action) => {
        state.isLoading = false
        state.reportRegionMatrix = action.payload?.data?.data
      })
      .addCase(getRegionMatrixReport.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
  }
})

export default ReportSlice.reducer
